import dayjs from 'dayjs';

import { CLACode, MaxCLASetting, SentMaxCLASetting } from '../types';

export const convertPayloadForSave = (
  data: MaxCLASetting
): SentMaxCLASetting => {
  return {
    claDateId: data.claDateId,
    claId: data.claId,
    value: data.value,
    type: data.type,
    valid: {
      from: dayjs(data.valid.from).startOf('day').toISOString(),
      to: dayjs(data.valid.to).startOf('day').toISOString()
    }
  };
};

export const convertResponseToOptions = (response: CLACode[] | undefined) => {
  return response
    ? response.map((data) => {
        return {
          value: data.claId,
          label: data.code
        };
      })
    : [];
};
